import { Query } from '../Model/Query';
import { Diligence } from '../Model/Diligence';
export class DiligencesService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('diligences/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener la diligencia.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener DiligenceId.`);
        }
    }
    async findDiligencesByThird(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('diligencesByThird/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de diligencia.`);
            }
            return await response.json();
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async findDiligences(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`diligences?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener las diligencias.`);
            }
            const content = await response.json();
            return content.map(diligence => new Diligence(diligence).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveDiligence(diligence) {
        if (diligence) {
            const response = await this.apiService.post('diligences', diligence instanceof Diligence ? diligence.getState() : diligence);
            if (!response.ok) {
                throw new Error(`Error al guardar la diligencia.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async findLastDiligenceNumber(year) {
        if (year) {
            const response = await this.apiService.get('diligenceNumber/' + year);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de diligencia.`);
            }
            const content = await response.text();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async getDiligencesQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`diligencesQuantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener las diligencias.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
